import { Component, OnInit, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow
} from "@angular/material/table";
import { Ticket } from "@app/models/rest/ticket";
import { Visit } from "@app/models/rest/visit";
import { VisitStore } from "@app/services/store/visit-store";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MomentModule } from "ngx-moment";

@Component({
  selector: "app-manage-attendance-dialog",
  templateUrl: "./manage-attendance-dialog.component.html",
  styleUrls: ["./manage-attendance-dialog.component.css"],
  imports: [
    MatProgressBar,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MomentModule
  ]
})
export class ManageAttendanceDialogComponent implements OnInit {
  dialogRef =
    inject<MatDialogRef<ManageAttendanceDialogComponent>>(MatDialogRef);
  visitStore = inject(VisitStore);
  data = inject(MAT_DIALOG_DATA);

  public ticketData: MatTableDataSource<Ticket> =
    new MatTableDataSource<Ticket>();
  public displayedColumns = [
    "id",
    "ticketStatus",
    "skillProfile",
    "resourceAvailability",
    "startTime",
    "duration"
  ];
  public loading = true;
  public visit: Visit;

  ngOnInit() {
    // console.log(this.data.visit.ticketList);
    // this.visit = this.data.visit;
    // this.visitStore.loadSingle(this.visit.id, null, 'detail').then(value => {
    //   console.log(value);
    // });

    this.loading = false;
    if (this.data && this.data.visit) {
      this.ticketData.data = this.data.visit.ticketList;
    }
  }
}
